module.exports = __webpack_public_path__ + "static/media/allow.a47eddef.mp3";